var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "default-modal",
    {
      attrs: {
        name: "invoice-send-modal",
        actionLabel: _vm.$t("send"),
        autofocus: _vm.$refs.message,
        successHandler: _vm.successHandler,
        title: _vm.$t("invoice_send_modal_title"),
        width: "md"
      },
      on: { show: _vm.handleShow },
      model: {
        value: _vm.opened,
        callback: function($$v) {
          _vm.opened = $$v
        },
        expression: "opened"
      }
    },
    [
      !_vm.success
        ? _c(
            "template",
            { slot: "content" },
            [
              _vm.addresses.length
                ? _c(
                    "q-field",
                    {
                      staticClass: "q-ma-none",
                      attrs: {
                        error: _vm.errors.has("email_address"),
                        "error-label": _vm.errors.first("email_address")
                      }
                    },
                    [
                      _c(
                        "q-input",
                        {
                          attrs: {
                            type: "email",
                            name: "emailAddress",
                            "float-label": _vm.$t("email_to"),
                            "hide-underline": ""
                          },
                          model: {
                            value: _vm.formData.address,
                            callback: function($$v) {
                              _vm.$set(_vm.formData, "address", $$v)
                            },
                            expression: "formData.address"
                          }
                        },
                        [
                          _c("q-autocomplete", {
                            attrs: {
                              "static-data": {
                                field: "value",
                                list: _vm.addresses
                              },
                              "min-characters": 0
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _c(
                    "q-field",
                    {
                      staticClass: "q-ma-none",
                      attrs: {
                        error: _vm.errors.has("email_address"),
                        "error-label": _vm.errors.first("email_address")
                      }
                    },
                    [
                      _c("q-input", {
                        attrs: {
                          type: "email",
                          name: "emailAddress",
                          "float-label": _vm.$t("email_to")
                        },
                        model: {
                          value: _vm.formData.address,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "address", $$v)
                          },
                          expression: "formData.address"
                        }
                      })
                    ],
                    1
                  ),
              _c("vue-simplemde", {
                ref: "markdown",
                staticClass: "q-mt-lg",
                attrs: { configs: _vm.simpleMdeConfig },
                model: {
                  value: _vm.formData.message,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "message", $$v)
                  },
                  expression: "formData.message"
                }
              })
            ],
            1
          )
        : _c(
            "template",
            { slot: "content" },
            [
              _c("check-mark"),
              _c("h4", { staticClass: "text-center" }, [
                _vm._v(_vm._s(_vm.$t("send_modal_successful_title")))
              ]),
              _c("p", { staticClass: "text-center" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t("invoice_send_modal_successful_body", {
                      address: _vm.formData.address
                    })
                  )
                )
              ])
            ],
            1
          )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }